import {
  KSendSuccessResponse,
  TableFilterCustomizationDataDto,
  TableFilterCustomizationDataDtoResponse,
} from '@asset-metrix/portal-gateway-client-js';
import { MutationFunction, QueryFunction } from '@tanstack/react-query';

import { portalGatewayClient } from '../portalGatewayClient';

type FetchTableFilterCustomizationQueryKey = readonly [
  string,
  { widgetId: string },
];

export const fetchTableFilterCustomization: QueryFunction<
  TableFilterCustomizationDataDtoResponse | null,
  FetchTableFilterCustomizationQueryKey
> = async ({ queryKey }) => {
  const [, { widgetId }] = queryKey;
  const result =
    await portalGatewayClient.table.getTableFilterCustomization(widgetId);

  return result.data;
};

export const mutateTableFilterCustomization: MutationFunction<
  KSendSuccessResponse,
  { widgetId: string; data: TableFilterCustomizationDataDto }
> = async ({ widgetId, data }) => {
  const response = await portalGatewayClient.table.putTableFilterCustomization(
    widgetId,
    data
  );

  return response.data;
};

export const deleteTableFilterCustomization: MutationFunction<
  KSendSuccessResponse,
  { widgetId: string }
> = async ({ widgetId }) => {
  const response =
    await portalGatewayClient.table.deleteTableFilterCustomization(widgetId);

  return response.data;
};
